export default "__VITE_ASSET__8FP1AYSp__"